import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "select_text_wrapper" }
const _hoisted_3 = { class: "select_text" }
const _hoisted_4 = { class: "badge_wrapper" }
const _hoisted_5 = { class: "badge_text" }
const _hoisted_6 = ["onClick"]

import { ref, onMounted, computed, watch, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { CollegeDetail } from '@/api/Models/HomeConfig'
import { College } from '@/api/Models/CollegeList'
import { useUsersStore } from '@/stores/users'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/login'
import { useCommunityStore } from '@/stores/community'
import { isFeishu } from '@/utils/feishu'
import { getMessageUnreadCount } from '@/api/requests/NewsRequests'
import CookieBanner from '@/components/CookieBanner.vue'
import { useCookieConsent } from '@/composables/useCookieConsent'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeHeader',
  props: {
    collegeDetail: {},
    collegeList: {}
  },
  emits: ['setIdHandle'],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v4b49be76": (_unref(themeColor)),
  "v72dba8f3": (_unref(themeColorWithAlpha))
}))


const emit = __emit

// 替换原先从 localStorage 读取的 token，改为从 Pinia 派生，保持响应式
const authStore = useAuthStore()
const token = computed(() => authStore.getAccessToken)
const shouldShowHeader = computed(() => !isFeishu || !!token.value)

const count = ref('0')

const getMsgCount = async () => {
  const res = await getMessageUnreadCount()
  if (res.code === 1) {
    count.value = String(res.data)
  }
}

// 延迟创建 SSE：仅在 token 可用或非飞书环境时触发
onMounted(() => {
  if (!isFeishu || !!token.value) {
    getMsgCount()
  }
  checkConsentStatus().finally(() => updateHeaderTop())
  window.addEventListener('scroll', onScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})

// 监听 token，在飞书环境下 token 到位后再建立 SSE
watch(token, (val) => {
  if (isFeishu && val) {
    getMsgCount()
  }
})

const router = useRouter()
const searchHandle = () => {
  router.push('/courseSearch')
}

// Cookie同意
const {
  needConsent,
  isUpdate,
  presentationUrl,
  checkConsentStatus,
  acceptConsent,
  submitPendingConsentLog
} = useCookieConsent()

const scrollY = ref(0)
const headerTop = ref('0')

function updateHeaderTop() {
  if (!needConsent.value) {
    headerTop.value = '0'
    return
  }
  const bannerEl = document.querySelector('.cookie-banner')
  if (bannerEl) {
    const bottom = bannerEl.getBoundingClientRect().bottom
    headerTop.value = Math.max(0, bottom) + 'px'
  }
}

let rafId = 0
function onScroll() {
  scrollY.value = window.scrollY
  if (!rafId) {
    rafId = requestAnimationFrame(() => {
      updateHeaderTop()
      rafId = 0
    })
  }
}

async function onCookieAccept(type: 'necessary' | 'all') {
  await acceptConsent(type)
  const userIdentifier = authStore.username || authStore.userId || 'anonymous'
  submitPendingConsentLog(userIdentifier)
  updateHeaderTop()
}

const usersStore = useUsersStore()
const { collegeId } = storeToRefs(usersStore)
const selectCollege = (id: string) => {
  emit('setIdHandle', id)
  masterShow.value = false
  const communityStore = useCommunityStore()
  communityStore.setIsRefresh(true)
}

const skipPage = () => {
  router.push('/news')
}

const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.08)

const masterShow = ref()
const hideMaster = () => {
  masterShow.value = false
}
const showMaster = () => {
  masterShow.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(needConsent))
      ? (_openBlock(), _createBlock(CookieBanner, {
          key: 0,
          "is-update": _unref(isUpdate),
          "presentation-url": _unref(presentationUrl),
          onAccept: onCookieAccept
        }, null, 8, ["is-update", "presentation-url"]))
      : _createCommentVNode("", true),
    (shouldShowHeader.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "home_header_container",
          style: _normalizeStyle({ top: headerTop.value })
        }, [
          _createElementVNode("div", {
            class: "college_wrapper",
            onClick: showMaster
          }, [
            _createElementVNode("img", {
              src: __props.collegeDetail.whiteLogoPreviewUrl,
              class: "home_title_img"
            }, null, 8, _hoisted_1),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title_separator" }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(__props.collegeDetail.collegeName), 1),
              _createElementVNode("i", {
                class: _normalizeClass(["iconfont icon-icon_shouye_xiala select_icon", { roate: masterShow.value }])
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", {
            class: "icon_wrapper",
            onClick: searchHandle
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "iconfont icon-daohanglansousuo icon_item" }, null, -1)
          ]))]),
          _createElementVNode("div", {
            class: "icon_wrapper",
            onClick: skipPage
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "iconfont icon-daohanglanxiaoxi icon_item" }, null, -1)),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(parseInt(count.value) > 99 ? '99+' : count.value), 1)
            ], 512), [
              [_vShow, count.value !== '0']
            ])
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "master",
            style: _normalizeStyle({ top: headerTop.value }),
            onClick: hideMaster,
            onTouchmove: hideMaster
          }, [
            _createVNode(_Transition, { name: "pull" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", {
                  class: "select_wrapper",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                  onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.collegeList, (item) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: _normalizeClass(["select_item", { active: _unref(collegeId) === item.id }]),
                      key: item.id,
                      onClick: ($event: any) => (selectCollege(item.id))
                    }, _toDisplayString(item.collegeName), 11, _hoisted_6))
                  }), 128))
                ], 544), [
                  [_vShow, masterShow.value]
                ])
              ]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "triangle" }, null, -1))
          ], 36), [
            [_vShow, masterShow.value]
          ])
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})